import { isEmpty } from 'lodash-es'

// Libs
import getSearchParams from '@/methods/url/getSearchParams'
import getUrlWithNewSearch from '@/methods/url/getUrlWithNewSearch'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'
import { STORAGE_DATA } from '@/constants/storageData'

export const handleLoginOrRegister = async ({
  isLogin = true,
  router,
  hasUserData = false,
  // setUserRecordMutation,
  fixedPlayerData = {},
  isGoRedirect = false,
}: // gtmLocation = '',
{
  isLogin?: boolean
  router: any
  hasUserData?: boolean
  // setUserRecordMutation: any
  fixedPlayerData: any
  isGoRedirect?: boolean
  // gtmLocation?: string
  locale?: string
}) => {
  if (hasUserData) return

  const searchParams: any = getSearchParams()

  const { asPath } = router

  const redirectUrl = `${window.location.origin}/${ROUTE_PATH.REDIRECT}?path=${asPath}`
  const redirectUrlWithSearch =
    getUrlWithNewSearch({
      url: redirectUrl,
      isLowerCase: false,
      searchParams: searchParams,
    }) || redirectUrl

  // 有些頁面登入回來要先導去 /redirect 再回原本頁面 // TODO: 例如直播間，因為目前直接回原本頁面可能 user-auth 還沒跑完，這時拿 profile 會有問題
  const redirectPath = isGoRedirect ? redirectUrlWithSearch.replace(window.location.origin, '') : asPath

  if (!isEmpty(fixedPlayerData?.liveUrlInfo)) {
    window.sessionStorage.setItem(STORAGE_DATA.FIXED_PLAYER_CACHE_DATA, JSON.stringify(fixedPlayerData))
  }

  // v2：改導站內登入/註冊頁（取代舊 passport 導頁），登入後由 /login 的 redirect 參數導回
  const loginOrRegisterPath = isLogin ? ROUTE_PATH.LOGIN : ROUTE_PATH.REGISTER
  router.push(`${loginOrRegisterPath}?redirect=${encodeURIComponent(redirectPath)}`)
}
